import axios from "../util/axios";
import Token from "../util/Token";

const COMPANY_URL = "/cms/v2/company";
const TEAM_URL = "/cms/v1/team";

// Company flag that controls the Vehicle Charging section of the V2 dashboard.
// All reads are resilient — they default to off, so nothing ever blocks render.

// Effective flag for the team the dashboard is showing: ON if the team or its parent
// company has it on.
async function getTeamVehicleChargingConfig(teamId) {
  try {
    Token.setAuthToken();
    const { status, data } = await axios.get(`${TEAM_URL}/${teamId}/vehicle-charging-config`);
    if (status === 200 && data.success) {
      return { vehicleChargingEnabled: data.data?.vehicleChargingEnabled === true };
    }
    return { vehicleChargingEnabled: false };
  } catch (error) {
    return { vehicleChargingEnabled: false };
  }
}

// A company's OWN setting (super-admin Company → Settings tab).
async function getCompanyVehicleChargingConfig(companyId) {
  try {
    Token.setAuthToken();
    const { status, data } = await axios.get(`${COMPANY_URL}/${companyId}/vehicle-charging-config`);
    if (status === 200 && data.success) {
      return { vehicleChargingEnabled: data.data?.vehicleChargingEnabled === true };
    }
    return { vehicleChargingEnabled: false };
  } catch (error) {
    return { vehicleChargingEnabled: false };
  }
}

async function updateCompanyVehicleChargingConfig(companyId, vehicleChargingEnabled) {
  Token.setAuthToken();
  const { data } = await axios.put(`${COMPANY_URL}/${companyId}/vehicle-charging-config`, {
    vehicleChargingEnabled: vehicleChargingEnabled === true,
  });
  return { vehicleChargingEnabled: data?.data?.vehicleChargingEnabled === true };
}

const vehicleChargingConfigService = {
  getTeamVehicleChargingConfig,
  getCompanyVehicleChargingConfig,
  updateCompanyVehicleChargingConfig,
};

export default vehicleChargingConfigService;
